import { WikiSalaryChartResponse } from '~hooks/query/company/useCompanyWikiChart';
import useGetMyInfoQuery from '~hooks/query/user/useMyInfoQuery';
import useMedia from '~hooks/useMedia';
import { COMPANYS_SOURCE_VALUE, IWikiChart } from '~types/company';
import { setGtmDataLayer } from '~utils/common/thirdPartyEvent';

import { useConstants, useModalOpen } from '../../hooks';
import ModalSalaryInfo from '../../ModalSalaryInfo';
import StakeBarGraph from '../../SalaryStakeBarGraph';
import { S } from '../../style';
import ButtonDetail from '../ButtonDetail';
import SignupNudgeWikiChart from '../SignupNudgeWikiChart';

interface Props {
  data: WikiSalaryChartResponse;
  companyId: string;
  graphData: IWikiChart;
  selectSource: COMPANYS_SOURCE_VALUE;
  careerType: 'rookie' | 'career';
}

export default function GraphContents({
  companyId,
  data,
  graphData,
  careerType,
  selectSource,
}: Props) {
  const { isActiveUser } = useGetMyInfoQuery();
  const { isMobile } = useMedia();
  const { isModalOpen, setIsModalOpen, modalInfo, handleModalOpen } = useModalOpen(data);
  const { CAREER_EMPLOYEE_NAV_DATA, NEW_EMPLOYEE_NAV_DATA } = useConstants();

  const handleClickChart = (chartIndex: number) => {
    const type = careerType === 'rookie' ? '신입' : '경력';
    const defaultMenuValue =
      careerType === 'rookie'
        ? NEW_EMPLOYEE_NAV_DATA[chartIndex].value
        : CAREER_EMPLOYEE_NAV_DATA[chartIndex].value;

    const gtmProperty: any = {
      graphType: `${type} 예상 연봉`,
      education: null,
      career: null,
      date: null,
      avgSalary: null,
    };

    if (careerType === 'rookie') {
      gtmProperty['education'] = NEW_EMPLOYEE_NAV_DATA[chartIndex].label;
    } else {
      gtmProperty['career'] = CAREER_EMPLOYEE_NAV_DATA[chartIndex].label;
    }

    setGtmDataLayer('company__salary__graph__click', gtmProperty);

    handleModalOpen({ type, defaultMenuValue });
  };

  return (
    <>
      {!isActiveUser ? (
        <SignupNudgeWikiChart companyId={companyId} type={careerType} />
      ) : (
        <S.GraphCard paddingLeft={isMobile ? '8px' : '18px'}>
          <StakeBarGraph
            graphData={graphData}
            onClickChart={(evt, chartIndex) => handleClickChart(chartIndex)}
          />
          <S.ButtonWrapper>
            <ButtonDetail
              data-attribute-id='company__salary__seeMore'
              data-click-type={careerType === 'rookie' ? '신입 예상 연봉' : '경력 예상연봉'}
              onClick={() =>
                handleModalOpen({
                  type: careerType === 'rookie' ? '신입' : '경력',
                })
              }
            />
          </S.ButtonWrapper>
        </S.GraphCard>
      )}
      {isModalOpen && modalInfo && (
        <ModalSalaryInfo
          companyId={companyId}
          navData={modalInfo.navData}
          title={modalInfo.title}
          defaultMenuValue={modalInfo.defaultMenuValue}
          prefix={modalInfo.type}
          isOpen={isModalOpen}
          salaryData={data}
          companySource={selectSource}
          handleClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
}
